<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Legislações
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        | ,
        strong  exibir
        | ,
        strong  criar
        |  e
        strong  editar
        |  legislações (com anexo) em
        strong  Configurações → Legislações
        | .

      .toast.toast-primary
        | Exige
        strong  Sistema → Legislações → Listar
        | ,
        strong  Exibir
        | ,
        strong  Criar
        |  e
        strong  Alterar
        |  conforme a ação.

      h5.h5 1. Abrir Legislações
      ol
        li No menu lateral, clique em
          strong  Configurações
          | .
        li Clique em
          strong  Legislações
          | .

      h5.h5 2. Listagem
      p
        | Filtre por
        strong  Título
        | . Cada card mostra o título e as datas de inserção/alteração.
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de legislações")
      ol
        li Clique no
          strong  +
          |  para criar.
        li Clique no ícone de
          strong  exibir
          |  (olho) para abrir a ficha.

      h5.h5 3. Exibir
      p
        | A ficha mostra
        strong  Título
        | ,
        strong  Descrição
        |  e o
        strong  Anexo
        |  (miniatura/link ou “Sem anexo”).
      figure.manual-figure
        img(:src="imgShow" alt="Exibição da legislação")
      ol
        li Clique em
          strong  Editar
          |  para alterar.

      h5.h5 4. Criar ou editar com anexo
      ol
        li Preencha
          strong  Título
          |  e
          strong  Descrição
          | .
        li Em
          strong  Anexo
          | , clique em
          strong  Anexar arquivo
          |  (ou
          strong  Editar Anexo
          |  na edição).
        li No modal, envie
          strong  imagem ou PDF
          | , acompanhe o progresso e confirme
          strong  Salvar
          |  no modal (pode remover o anexo antes de confirmar).
        li Clique em
          strong  Salvar
          |  no formulário. Na criação você volta à listagem; na edição, à ficha de exibição.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/44-config-legislacoes-lista.png"),
      imgShow: require("@/assets/manuais/44a-config-legislacoes-show.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
